import React from "react";


const TermsAndConditions = () => {
  return (
    <div className="terms-container">
      <h1 className="terms-title">Terms & Conditions</h1>

      <p className="terms-date">
        <strong>Effective Date:</strong> 12th January 2026
      </p>

      <p>
        By using the <strong>DigiDoc</strong> mobile app ("App"), you agree to the
        following Terms and Conditions ("Terms"). Please read them carefully.
      </p>

      <section>
        <h3>1. Use of Service</h3>
        <p>
          The App provides tools for booking healthcare appointments, managing
          treatments, and storing health records. You agree to:
        </p>
        <ul>
          <li>Provide accurate and complete information.</li>
          <li>Use the app only for lawful and personal purposes.</li>
          <li>Not misuse the app or attempt unauthorized access.</li>
        </ul>
      </section>

      <section>
        <h3>2. Medical Disclaimer</h3>
        <p>
          The App provides information and tools to assist your healthcare
          journey but does not replace professional medical advice. Always
          consult your doctor about medical concerns.
        </p>
      </section>

      <section>
        <h3>3. User Accounts</h3>
        <p>
          You are responsible for maintaining the confidentiality of your
          account credentials. Notify us immediately of any unauthorized
          access.
        </p>
      </section>

      <section>
        <h3>4. Intellectual Property</h3>
        <p>
          All app content, design, logos, and software are owned by DigiDoc and
          protected under intellectual property laws. Do not copy, modify, or
          distribute without permission.
        </p>
      </section>

      <section>
        <h3>5. Limitation of Liability</h3>
        <ul>
          <li>Medical outcomes or decisions made using the app.</li>
          <li>Errors, interruptions, or delays in the app.</li>
          <li>Third-party content or services.</li>
        </ul>
      </section>

      <section>
        <h3>6. Termination</h3>
        <p>
          We may suspend or terminate your account if you violate these Terms or
          misuse the service.
        </p>
      </section>

      <section>
        <h3>7. Governing Law</h3>
        <p>
          These Terms are governed by the laws of Chennai, Tamil Nadu, India.
          Any disputes will be resolved under the exclusive jurisdiction of the
          courts in Chennai, Tamil Nadu, India.
        </p>
      </section>

      <section>
        <h3>8. Changes to Terms</h3>
        <p>
          We may update these Terms periodically. We will notify you of
          significant changes via the app or email.
        </p>
      </section>

      <section>
        <h3>9. Contact Us</h3>
        <p>
          <strong>Email:</strong> support@digidoc.co.in <br />
          <strong>Address:</strong> S2, 21, Srinivasa Nagar, Kandanchavadi,
          Perungudi, Chennai, Tamil Nadu 600096.
        </p>
      </section>
    </div>
  );
};

export default TermsAndConditions;
